import React from 'react'

const NotesWizardData = ({ comment, setComment }: any) => {
  return (
    <div className='row'>
      <div className='col-md-12 mb-2'>
        <label>Comments </label>
        <textarea
          className='form-control'
          rows={5}
          style={{ width: '100%' }}
          value={comment}
          onChange={(e: any) => setComment(e.target?.value)}
        />
      </div>
    </div>
  )
}

export default NotesWizardData